import { AssistChip, Stack, Text } from '@sixui/ui';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import type { ITableRowProps } from '~/components/molecules/Table';
import type { IIapPoll } from '~/lib/api/modules/IapPolls';
import { RelativeTime } from '~/components/atoms/RelativeTime';
import { Table } from '~/components/molecules/Table';
import { getIapPollInfo } from './getIapPollInfo';
import { IapPollListItemMenu } from './IapPollListItemMenu';

export type IIapPollListItemProps = ITableRowProps & {
  iapPoll: IIapPoll;
};

export const IapPollListItem: React.FC<IIapPollListItemProps> = (props) => {
  const { iapPoll, ...other } = props;
  const { t, i18n } = useTranslation();

  const actionUrl = `/apps/${iapPoll.appId}/iapPolls/${iapPoll._id}`;
  const locale = i18n.language;
  const iapPollInfo = getIapPollInfo(iapPoll);
  const start = iapPollInfo.startAt
    ? iapPollInfo.startAt.toLocaleString(DateTime.DATE_MED, { locale })
    : undefined;
  const end = iapPollInfo.endAt
    ? iapPollInfo.endAt.toLocaleString(DateTime.DATE_MED, { locale })
    : undefined;

  return (
    <Table.Row {...other}>
      <Stack as={Table.BodyAction} horizontal gap={3} href={actionUrl}>
        <Stack gap={1}>
          {(iapPoll.title || start || end) && (
            <Stack>
              {iapPoll.title && (
                <Text variant="label" size="lg">
                  {iapPoll.title}
                </Text>
              )}

              {(start || end) && (
                <Text variant="body" size="md">
                  {start && end
                    ? t('common.dateRange', { start, end })
                    : start
                      ? t('common.fromDate', { start })
                      : end
                        ? t('common.untilDate', { end })
                        : undefined}
                </Text>
              )}
            </Stack>
          )}
        </Stack>
      </Stack>

      <Stack as={Table.Body} gap={1}>
        <div>
          <AssistChip label={t(`IapPollInfo.${iapPollInfo.status}`)} />
        </div>
        {iapPollInfo.programmedAt && (
          <Text variant="body" size="sm" dimmed>
            <RelativeTime date={iapPollInfo.programmedAt} />
          </Text>
        )}
      </Stack>

      <Stack as={Table.Body} horizontal justify="end">
        <IapPollListItemMenu iapPoll={iapPoll} />
      </Stack>
    </Table.Row>
  );
};
